<li
  class="sidebar-item"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <a
    class="sidebar-link"
    [routerLink]="getMenuLinkTo(menu)"
    *ngIf="menu.linkto !== 'url'; else externalLink"
  >
    <i class="bx" [ngClass]="getMenuIcon(menu.linkto)"></i>
    <!-- Truncated menu name -->
    <span class="truncate-text" [title]="menu.name">{{ menu.name }}</span>
    <i *ngIf="menu.children?.length" class="bx bx-caret-right toggle-caret"></i>
  </a>

  <!-- External URL -->
  <ng-template #externalLink>
    <a class="sidebar-link" [href]="getMenuLinkTo(menu)" target="_blank">
      <i class="bx" [ngClass]="getMenuIcon(menu.linkto)"></i>
      <span>{{ menu.name }}</span>
      <i
        *ngIf="menu.children?.length"
        class="bx bx-caret-right toggle-caret"
      ></i>
    </a>
  </ng-template>

  <!-- Submenu -->
  <div
    class="floating-submenu-global"
    *ngIf="showSubmenu && menu.children?.length"
    [ngStyle]="{ top: submenuTop + 'px', left: submenuLeft + 'px' }"
  >
    <ul>
      <li *ngFor="let child of menu.children" class="submenu-item">
        <app-menu-item [menu]="child" [level]="level + 1"></app-menu-item>
      </li>
    </ul>
  </div>
</li>
